import { Button, SlideOver } from '@GxT-Team/gxt-components';
import Comment from '../../../../components/Comment';
import { CommentsSlideOverProps } from '../../types';

const CommentsSlideOver = ({
  isOpen,
  onClose,
  comments,
  onNavigateToTarget,
}: CommentsSlideOverProps) => {
  return (
    <SlideOver
      isOpen={isOpen}
      onClose={onClose}
      width="24rem"
      mountElementId="styled-wrapper"
      dataTestId="comments-slideover">
      <SlideOver.Header className="bg-primary-50 text-white">Comments</SlideOver.Header>
      {onNavigateToTarget && (
        <p className="px-4 py-2 text-xs text-neutral-500 border-b border-neutral-200">
          Click a comment to scroll to its table cell or paragraph in the target document.
        </p>
      )}
      {comments.map((comment) => (
        <Comment
          name={`${comment.firstName} ${comment.lastName}`}
          message={comment.comment}
          key={comment.commentNumber}
          onClick={
            onNavigateToTarget && comment.targetNodeId
              ? () => onNavigateToTarget(comment.targetNodeId)
              : undefined
          }
        />
      ))}
      <SlideOver.Footer className="text-white">
        <Button variant="secondary" onClick={onClose} className="ml-auto">
          Close
        </Button>
      </SlideOver.Footer>
    </SlideOver>
  );
};

export default CommentsSlideOver;
